import axios from 'axios';
import { appConfig } from '../../Config/app';

const organizationAPI = axios.create({
  baseURL: appConfig.API_BASE_URL,
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
});

function apiUpdateOrganization(action) {
  return organizationAPI.patch(
    `/api/v1/organisation/${action.organizationId}/`,
    action.data,
    { headers: { Authorization: `Token ${action.token}` } },
  );
}

export const organizationServices = {
  apiUpdateOrganization,
};
